export const statusColorScheme = {
    colorBlack: '#d0dbe0',
    colorWhite: '#ffffff'
};
